import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import FormFieldMediumRow from '../components/FormFieldMediumRow';

export const GET_MEDIUM = gql`
  query GetMedium($id: ID!) {
    medium(id: $id) {
      id
      ...FormFieldMediumRowMedium
    }
  }

  ${FormFieldMediumRow.fragments.medium}
`;

const propTypes = {
  mediumId: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  altField: PropTypes.string.isRequired,
  titleField: PropTypes.string.isRequired,
  onResetDefault: PropTypes.string.isRequired,
  submitted: PropTypes.bool,
};

const defaultProps = {
  submitted: false,
};

const FormFieldMediumRowContainer = ({
  mediumId,
  setFieldValue,
  altField,
  titleField,
  onResetDefault,
  submitted,
  ...rest
}) => {
  const { data, loading, refetch, networkStatus } = useQuery(
    GET_MEDIUM, {
      variables: { id: mediumId },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (submitted) {
      refetch();
    }
  }, [submitted]);

  useEffect(() => {
    if (!loading && data && data.medium) {
      setFieldValue(altField, data.medium.defaultMetadata.altText || '');
      setFieldValue(titleField, data.medium.defaultMetadata.title || '');
    }
  }, [loading, networkStatus.refetch]);

  if (loading) {
    return null;
  }

  return (
    <FormFieldMediumRow
      {...rest}
      onResetDefault={onResetDefault}
      image={data.medium}
      setFieldValue={setFieldValue}
      altField={altField}
      titleField={titleField}
    />
  );
};

FormFieldMediumRowContainer.propTypes = propTypes;
FormFieldMediumRowContainer.defaultProps = defaultProps;

export default FormFieldMediumRowContainer;
